import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../store/slices/authSlice";
import { useGetAdminDashboardStatsQuery } from "../../../services/api";
import "./Admindashboard.css";

/** Tiny inline icons so we don't add deps */
const IconCompany = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_199_1377)">
    <path d="M2.66675 14.0001V4.00008C2.66675 3.33341 3.33341 2.66675 4.00008 2.66675H7.33341C8.00008 2.66675 8.66675 3.33341 8.66675 4.00008V14.0001" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.6667 5.33325H12.0001C12.6667 5.33325 13.3334 5.99992 13.3334 6.66659V13.9999" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2 14H14" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_199_1377">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>
);
const IconCalendar = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_199_1386)">
    <path d="M5.33325 9.5C5.33325 9.776 5.55725 10 5.83325 10H6.83325C6.96586 10 7.09304 9.94732 7.18681 9.85355C7.28057 9.75979 7.33325 9.63261 7.33325 9.5V6.5C7.33325 6.36739 7.28057 6.24022 7.18681 6.14645C7.09304 6.05268 6.96586 6 6.83325 6H5.83325C5.70064 6 5.57347 6.05268 5.4797 6.14645C5.38593 6.24022 5.33325 6.36739 5.33325 6.5V7.5C5.33325 7.776 5.55725 8 5.83325 8H7.33325" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.33325 7V9C9.33325 9.26522 9.43861 9.51957 9.62615 9.70711C9.81368 9.89464 10.068 10 10.3333 10C10.5985 10 10.8528 9.89464 11.0404 9.70711C11.2279 9.51957 11.3333 9.26522 11.3333 9V7C11.3333 6.73478 11.2279 6.48043 11.0404 6.29289C10.8528 6.10536 10.5985 6 10.3333 6C10.068 6 9.81368 6.10536 9.62615 6.29289C9.43861 6.48043 9.33325 6.73478 9.33325 7Z" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_199_1386">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>
);

// KPI Icons
const KpiIcon = ({ type }) => {
  switch (type) {
    case "users":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clip-path="url(#clip0_199_1366)">
            <path
              d="M3.33325 4.66667C3.33325 5.37391 3.6142 6.05219 4.1143 6.55229C4.6144 7.05238 5.29267 7.33333 5.99992 7.33333C6.70716 7.33333 7.38544 7.05238 7.88554 6.55229C8.38563 6.05219 8.66659 5.37391 8.66659 4.66667C8.66659 3.95942 8.38563 3.28115 7.88554 2.78105C7.38544 2.28095 6.70716 2 5.99992 2C5.29267 2 4.6144 2.28095 4.1143 2.78105C3.6142 3.28115 3.33325 3.95942 3.33325 4.66667Z"
              stroke="#2A987A"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 14V12.6667C2 11.9594 2.28095 11.2811 2.78105 10.781C3.28115 10.281 3.95942 10 4.66667 10H7.33333C8.04058 10 8.71885 10.281 9.21895 10.781C9.71905 11.2811 10 11.9594 10 12.6667V14"
              stroke="#2A987A"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.6667 2.08667C11.2404 2.23354 11.7488 2.56714 12.1118 3.03488C12.4749 3.50262 12.672 4.07789 12.672 4.67C12.672 5.26212 12.4749 5.83739 12.1118 6.30513C11.7488 6.77287 11.2404 7.10647 10.6667 7.25334"
              stroke="#2A987A"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14 14.0001V12.6668C13.9966 12.0782 13.7986 11.5073 13.4368 11.043C13.0751 10.5788 12.5699 10.2472 12 10.1001"
              stroke="#2A987A"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_199_1366">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "chart":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clipPath="url(#clip0_199_1406)">
            <path
              d="M5.70668 2.45996C4.97873 2.76129 4.31726 3.20302 3.76001 3.75996"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.46 5.70679C2.1577 6.43365 2.0014 7.2129 2 8.00012"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.45996 10.2932C2.76129 11.0212 3.20302 11.6826 3.75996 12.2399"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.70679 13.54C6.43365 13.8423 7.2129 13.9986 8.00012 14"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.2932 13.54C11.0212 13.2387 11.6826 12.7969 12.2399 12.24"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.54 10.2933C13.8423 9.56647 13.9986 8.78722 14 8"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.54 5.70668C13.2387 4.97873 12.7969 4.31726 12.24 3.76001"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.2933 2.46C9.56647 2.1577 8.78722 2.0014 8 2"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_199_1406">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "trending":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clipPath="url(#clip0_199_1444)">
            <path
              d="M3.33325 8.00008L6.66659 11.3334L13.3333 4.66675"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_199_1444">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "calendar":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clipPath="url(#clip0_199_1453)">
            <path
              d="M2 11.3334L6 7.33341L8.66667 10.0001L14 4.66675"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.33325 4.66675H13.9999V9.33341"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_199_1453">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    default:
      return null;
  }
};

export default function AdminDashboard() {
  const user = useSelector(selectCurrentUser);

  /* ---------- Filters ---------- */
  const [companyId, setCompanyId] = useState("");
  const [range, setRange] = useState("90");

  const periodMap = { "30": 30, "60": 60, "90": 90, "365": 365 };

  const { data, isLoading } = useGetAdminDashboardStatsQuery({
    companyId: companyId || undefined,
    period: periodMap[range] || 90,
  });

  const kpis = data?.kpis || {};

  const kpiCards = [
    { label: "Total Users", value: kpis.totalUsers ?? "...", icon: "users" },
    { label: "Diagnostics Submitted", value: kpis.diagnosticSubmissions ?? "...", icon: "chart" },
    { label: "Active Dev Plans", value: kpis.activeDevelopmentPlans ?? "...", icon: "trending" },
    { label: "Community Events", value: kpis.communityEvents ?? "...", icon: "calendar" },
  ];

  /* ---------- Chart data from API ---------- */
  const monthly = useMemo(() => {
    if (!data?.monthlyTrends?.length) return [];
    return data.monthlyTrends.map((t) => ({
      m: t.month,
      v: t.diagnostics + t.surveys,
    }));
  }, [data?.monthlyTrends]);

  const byCompany = useMemo(() => {
    if (!data?.statsByCompany?.length) return [];
    return data.statsByCompany.slice(0, 5).map((c) => ({
      t: c.companyName?.length > 10 ? c.companyName.slice(0, 10) + "…" : c.companyName,
      v: c.memberCount,
    }));
  }, [data?.statsByCompany]);

  /* ---------- Recent diagnostics table ---------- */
  const rows = data?.recentDiagnostics || [];

  const displayName = user
    ? `${user.firstName || ""} ${user.lastName || ""}`.trim() || "Admin"
    : "Admin";

  return (
    <div className="adash">
      {/* Header */}
      <div className="adash-heading">
        <div className="adash-welcome-section">
          <div className="welcome">Welcome Back,</div>
          <h1 className="username">{displayName}</h1>
        </div>

        <div className="adash-filters">
          <div className="adash-filter">
            <IconCompany />
            <select
              value={companyId}
              onChange={(e) => setCompanyId(e.target.value)}
            >
              <option value="">All Companies</option>
              {(data?.companies || []).map((c) => (
                <option key={c._id} value={c._id}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>
          <div className="adash-filter">
            <IconCalendar />
            <select value={range} onChange={(e) => setRange(e.target.value)}>
              <option value="30">Last 30 Days</option>
              <option value="60">Last 60 Days</option>
              <option value="90">Last 90 Days</option>
              <option value="365">YTD</option>
            </select>
          </div>
        </div>
      </div>

      {/* KPI cards */}
      <div className="adash-kpis">
        {kpiCards.map((k) => (
          <div className="main-card" key={k.label}>
            <div className="maincard-head">
              <span className="summary-icon">
                <KpiIcon type={k.icon} />
              </span>
              <span className="maincard-title">{k.label}</span>
            </div>
            <div className="maincard-value">
              {isLoading ? "..." : k.value}
            </div>
          </div>
        ))}
      </div>

      {/* Charts */}
      <div className="adash-charts">
        <div className="adash-card">
          <div className="adash-card-head">Monthly Activity</div>
          <BarChart data={monthly} />
        </div>

        <div className="adash-card">
          <div className="adash-card-head">By Company</div>
          <BarChart data={byCompany} showLabelsKey="t" />
        </div>
      </div>

      {/* Table */}
      <div className="adash-card full">
        <div className="adash-card-head">Recent Diagnostics</div>

        <div className="adash-table-wrap">
          <table className="adash-table">
            <thead>
              <tr className="adash-dev-first">
                <th>Employee</th>
                <th>Company</th>
                <th>Status</th>
                <th>Type</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              ) : rows.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>
                    No diagnostics yet
                  </td>
                </tr>
              ) : (
                rows.map((r, i) => {
                  let statusClass = "status-pill";
                  if (r.status === "submitted") statusClass += " status-completed";
                  else if (r.status === "in_progress") statusClass += " status-pending";

                  return (
                    <tr key={i}>
                      <td>{r.employeeName}</td>
                      <td>{r.companyName}</td>
                      <td>
                        <span className={statusClass}>{r.status}</span>
                      </td>
                      <td>{r.evaluationType}</td>
                      <td>
                        {r.submittedAt
                          ? new Date(r.submittedAt).toLocaleDateString("en-US", {
                              month: "short",
                              day: "2-digit",
                            })
                          : "-"}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

/* --------- A tiny CSS-only bar chart component --------- */
function BarChart({ data, showLabelsKey }) {
  if (!data || data.length === 0) {
    return (
      <div className="bar-chart" style={{ textAlign: "center", padding: "2rem", color: "#999" }}>
        No data available
      </div>
    );
  }

  const max = Math.max(...data.map((d) => d.v), 1);
  // Dynamic Y-axis: 5 ticks from 0 to a nice rounded max
  const niceMax = Math.ceil(max / 5) * 5 || 5;
  const yTicks = [niceMax, Math.round(niceMax * 0.75), Math.round(niceMax * 0.5), Math.round(niceMax * 0.25), 0];

  return (
    <div className="bar-chart">
      <div className="chart-y-axis">
        {yTicks.map((t, i) => (
          <span key={i}>{t}</span>
        ))}
      </div>
      <div className="bars">
        {data.map((d, i) => {
          const h = (d.v / niceMax) * 100;
          const isMax = d.v === max && max > 0;
          return (
            <div className="bar-wrap" key={i} title={`${d.v}`}>
              <div
                className={`bar ${isMax ? "is-highlight" : ""}`}
                style={{ height: `${Math.min(h, 100)}%` }}
              >
                <span className="bar-label">{d.v}</span>
              </div>
              <div className="bar-x">
                {showLabelsKey ? d[showLabelsKey] : d.m}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
